import type { IEPGAsset, IEPGResponse } from 'models';
import maestroApiRequest from '../maestro-api-client';
import { store } from 'services';
import { getSiteId } from 'services/app';
import { EPG_SERVICE_BASE_URL } from 'config';
import Axios from 'axios';

type UnsubscribeFn = () => void;

export const makeEpgService = async (realtimeBridge: Realtime.Bridge) => {
  const onEpgChangeAtChannel = (
    id: string,
    callback: (asset?: IEPGAsset, nextAsset?: IEPGAsset) => void,
  ): Promise<UnsubscribeFn> => {
    const unsubscribe = realtimeBridge.subscribe<IEPGResponse>(
      `epg/${id}`,
      (epg) => {
        callback(epg.asset ?? undefined, epg.nextAsset ?? undefined);
      },
    );

    return Promise.resolve(() => {
      unsubscribe();
    });
  };

  const getEpg = async(
    id: string,
    captureCanceler?: (cancelFn: () => unknown) => unknown,
  ) => {
    const siteId = getSiteId(
      store().getState(),
    );

    const { data } = await maestroApiRequest({
      freshInstance: true,
      primaryToken: null,
      siteId,
    }).get<{ epg: IEPGResponse | null | undefined }>(
      EPG_SERVICE_BASE_URL + `/channel/${id}`,
      {
        cancelToken: new Axios.CancelToken(
          (canceler) => captureCanceler?.(canceler),
        ),
      },
    );

    return {
      asset: data.epg?.asset ?? undefined,
      nextAsset: data.epg?.nextAsset ?? undefined,
    };
  };

  return {
    getEpg,
    onEpgChangeAtChannel,
  };
};
